<div id="toggler" class="row py-2 align-items-center pe-3" (click)="isCollapsed = !isCollapsed">
    <div class="col-12 d-flex align-items-center my-1 gap-1">
        <div class="col-1">
            <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
        </div>
        <div class="col-4">{{ fedexLocation.Address.Description }}</div>
        <div class="col-3">{{ fedexLocation.Address.Street }}</div>
        <div class="col-2">{{ fedexLocation.Distance | roundMiles }}</div>
        <div class="col">
            <button
                type="button"
                class="btn btn-primary"
                (click)="selectFedexLocation($event)"
                [translate]="'MATERIAL_ORDER_FEDEX_SELECT_BTN_LABEL'"
            ></button>
        </div>
    </div>
</div>
@if (!isCollapsed) {
    <div class="row align-items-center mb-3 offset-1">
        <span class="col-lg-1 col-2 col-form-label text-start" [translate]="'MATERIAL_ORDER_FEDEX_CITY_LABEL'"></span>
        <div class="col">{{ fedexLocation.Address.City }}</div>

        <div class="col-12 d-flex flex-wrap gap-3 mt-2">
            @for (entry of getWeeklySchedule(fedexLocation) | keyvalue: compareKeys; track entry.key) {
                @if (entry.value?.Begin && entry.value?.End) {
                    <div class="d-flex gap-2 align-items-center">
                        <span class="fw-bold">{{ entry.key | titlecase }}</span>
                        <span>{{ entry.value.Begin }} - {{ entry.value.End }}</span>
                    </div>
                }
            }
        </div>
    </div>
}
